export default __webpack_public_path__ + "static/media/inline1.93916321.png";